import React from 'react';
import VoxelText from './Text/VoxelText';

export interface VoxelStepCounterProps {
  title: string;
  active: boolean;
}

export const VoxelStepCounter: React.FC<VoxelStepCounterProps> = ({
  title,
  active,
}) => {


  return (
    <div
      className={`
        rounded-full h-[22px] w-[22px] relative
         text-xs font-semibold
        ${active ? ' bg-voxel-gray-100' : ''}
        ${!active ? `  bg-voxel-gray-100` : ''}
        `}
    >
      <div className='absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2'>
        <VoxelText variant='table' className='font-semibold' color={active ? 'dark' : 'hint'}>
          {title}
        </VoxelText>
      </div>
    </div>

  );
};

export default VoxelStepCounter;
